import React from "react";
import {
  PickerItem as SpectrumPickerItem,
  type PickerItemProps,
} from "@react-spectrum/s2";

const SpectrumPicker = SpectrumPickerItem as React.FC<PickerItemProps>;

/** S2 types `PickerItem` as returning `ReactNode` (TS2786 under @types/react 18). */
export function PickerItem(props: PickerItemProps) {
  return <SpectrumPicker {...props} />;
}

export type { PickerItemProps };
